
import React, { useEffect } from "react";
import "./Loader.css";
import loaderlogo from '../../assets/images/loader-logo.png';

export default function Loader({ show = true, onComplete }) {
  useEffect(() => {
    const loader = document.getElementById('preloader');
    if (loader) {
      if (show) {
        loader.classList.remove('hide');
        loader.classList.add('show');
        loader.style.display = 'flex';
      } else {
        loader.classList.remove('show');
        loader.classList.add('hide');
        setTimeout(() => {
          loader.style.display = 'none';
          if (onComplete) onComplete();
        }, 300);
      }
    }
  }, [show, onComplete]);

  if (!show) return null;

  return (
    <div id="preloader" className="show">
      <div className="loader-overlay">
        <div className="loader-content">
          {/* Logo container */}
          <div className="loader-logo-box">
            <img src={loaderlogo} alt="Fynito" className="loader-logo" />
          </div>
          
          {/* Spinner animation */}
          <div className="loader-circle"></div>
          <div className="loader-line-mask">
            <div className="loader-line"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

